import { Link } from "react-router-dom";

interface LibraryNavigableRowLinkProps {
  to: string;
  ariaLabel: string;
}

export function LibraryNavigableRowLink({
  to,
  ariaLabel,
}: LibraryNavigableRowLinkProps) {
  return (
    <Link
      to={to}
      aria-label={ariaLabel}
      className="absolute inset-0 z-10 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-whart-dark"
    />
  );
}
